// extracted by mini-css-extract-plugin
export default {"header":"InactiveInviteView_header__QxKo4","description":"InactiveInviteView_description__fvsuZ","link":"InactiveInviteView_link__c7IWJ"};